import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import SvgIcon from '@material-ui/core/SvgIcon';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import { useReactToPrint } from 'react-to-print';
import './QuoteFor.scss';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Col, Row, Form, Modal } from "react-bootstrap";
import { TextInput } from '../../../Helpers/Inputs';
import Button from '@material-ui/core/Button';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem } from '../../../../sessionStorage';
import { httpRequest } from '../../../../httpRequest';
import { ConvertStringToBoolean } from '../../../Helpers/Formatters/ConvertBoolean';

export default function QuoteFor(props) {

  const handlePrint = useReactToPrint({
    copyStyles: true,
    content: () => props.content.current,
  })

  const [popup, setPopUp] = useState(false);
  const [saveQuoteName, setSaveQuoteName] = useState('');
  const [saveQuoteError, setSaveQuoteError] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePopUp = () => {
    if(saveQuoteError){
      props.setSaveQuoteError('');
    }
    setPopUp(true);
  }


  const saveQuote = () => {
    setLoading(true);
    setSaveQuoteError('');
    
    return new Promise((resolve, reject) => {

      let baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;
      const clientData = props.fullFormState.pages.retrieveAccount;
      const userData = getSessionStorageItem(ADVISOR_OBJECT_KEY);
      const body = {
        SavedQuoteName: saveQuoteName,
        ExternalUserID: userData && userData.externalUserId ,
        OfficeAccountNumber: clientData && clientData.officeAccount,
        BirthDate: props.fullFormState.pages.insuredBasicInfo.birthdate,
        Gender: props.fullFormState.pages.insuredBasicInfo.gender,
        MaritalStatus: props.fullFormState.pages.insuredBasicInfo.maritalStatus,
        Tobacco: props.fullFormState.pages.insuredBasicInfo.tobacco && ConvertStringToBoolean(props.fullFormState.pages.insuredBasicInfo.tobacco),
        State: props.fullFormState.pages.insuredBasicInfo.state,
        CoverageLength: props.formState.term,
        HealthClass: props.formState.healthClass,
        Substandard: props.formState.tableRating || null,
        FaceAmount: props.formState.coverageAmount && parseFloat(props.formState.coverageAmount),
        ChildRider: props.formState.childRider ? props.formState.benefitAmount && parseFloat(props.formState.benefitAmount) : null,
        AccidentalDBRider: props.formState.accidentalDeathBenefit,
        AcceleratedDBRider: props.formState.acceleratedDeathBenefit,
        WaiverOfPremium: props.formState.waverOfPremium
      }

      httpRequest.post(`${baseAddress}/api/MorganStanley/SaveQuote`, body).then((data) => {
        setLoading(false);
        props.setshowAlertMessage(false);
        if (data.content && data.content.messages && (data.content.messages.length > 0)) {
          if(data.content.messages[0].message)  {
            setSaveQuoteError(data.content.messages[0].message)
          }
        }else{
          setPopUp(false);
          setSaveQuoteName('');
          props.setshowAlertMessage(true);
          setSaveQuoteError('');
          setLoading(false);
        }
      }).catch(err => {
        reject(err)
        setLoading(false);
      }
      );
    });
  }

  const handleClose = () => {
    setPopUp(false);
    setSaveQuoteName('');
    setSaveQuoteError('');
    setLoading(false);
  }

  return (
    <div className="quote-for w-100" >
      <h3 className='px-4'>
        <strong>
          <NumberFormat value={props.coverageAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </strong>
        &nbsp;{props.separator && '- '} {props.term} Year Term Life Insurance
        {props.showPrintOrSave ?
          <Fragment>
            <span onClick={handlePrint}>
              <span className='float-right-class ml-2'>PRINT</span>
              <SvgIcon component={PrintOutlinedIcon} className='float-right-svg ml-3 mt-1' />
            </span>
            {
              !props.isProspectMode &&
              <React.Fragment>
                 <span onClick={() => handlePopUp()} className='float-right-class ml-2'>{loading ? <CircularProgress size={25} /> : 'SAVE'}</span>
                 <SvgIcon component={CloudUploadOutlinedIcon} className='float-right-svg mt-1' />
              </React.Fragment>
            }
            </Fragment> :
            <span className='float-right ml-2'>
              <CircularProgress size='1.6rem' color='white'/>
            </span>
        }        
      </h3>
      <Modal show={popup} onHide={() => handleClose()} backdrop="static" size="md">
        <Modal.Body>
            <div className="head-close d-flex mt-2">
              <Col md={6} lg={6}>
                <h4 className='ml-2 mt-2'>  
                  Save Quote
                </h4>
              </Col>
              <Col md={6} lg={6} className='text-right'>
                <IconButton className="close-button" aria-label="close" onClick={() => handleClose()}>
                  <CloseIcon />
                </IconButton>
              </Col>
            </div>
          <div className='mx-3'>
            <Form.Group>
                <TextInput
                    name="saveQuoteName"
                    id="saveQuoteName"
                    label="Save quote name"
                    value={saveQuoteName}
                    onChange={(e) => setSaveQuoteName(e.target.value)}
                />
            </Form.Group>
          </div>
          {saveQuoteError && (
            <div className="alert alert-danger mx-3">
              <span>{saveQuoteError}</span>
            </div>
          )}
          <Row className='mx-2'>
              <Col className="d-flex justify-content-end">
                <Form.Group>
                    <Button disabled={((saveQuoteName === '' ) || loading) ? true : false} onClick={()=> saveQuote()} type="submit" color="primary" variant="contained">
                      {loading  ? <CircularProgress size={25} /> : 'Save & Close'}
                    </Button>
                </Form.Group>
              </Col>
              <Col className="d-flex justify-content-start">
                <Form.Group>
                    <Button onClick={() => handleClose()} color="primary" variant="contained">
                        Cancel
                    </Button>
                </Form.Group>
              </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
}

QuoteFor.propTypes = {
  coverageAmount: PropTypes.number.isRequired,
  separator: PropTypes.bool,
};




// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/SubComponent/QuoteFor.js